/* eslint-disable no-nested-ternary */
import i18n from '../i18n';
import province from '../files/province.json';

export const displayDate = (timestamp) => {
  const date = new Date(timestamp);
  const day = date.getDate();
  const month = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const displayHour = (timestamp) => {
  const date = new Date(timestamp);
  const hours = date.getHours();
  const today = new Date();
  const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
  if (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  ) {
    return `${hours}:${minutes}`;
  }

  const day = date.getDate();
  const month = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
  const year = date.getFullYear();

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const displayChatHour = (timestamp) => {
  const date = new Date(timestamp);
  const hours = date.getHours();
  const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
  const today = new Date();
  if (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  ) {
    return `${hours}:${minutes}`;
  }
  const day = date.getDate();
  const month = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const displayMoney = (n) => {
  if (n === undefined) return '';
  if (n.price === undefined) return '';
  let currency = 'EUR';
  if (n.address.country === 'Svizzera') currency = 'CHF';
  const format = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency
  });
  return format.format(n.price);
};

export const displayAddress = (a) => {
  if (a.address) {
    if (a.address.country === 'Italia') {
      const provinceShort = province
        .filter((data) => data.nome === a.address.province)
        .map((data) => data.sigla);
      return `${a.address.municipality} (${provinceShort})`;
    }
    if (a.address.country === 'Svizzera') {
      return `${a.address.npa} (${a.address.country})`;
    }
  }
  return null;
};

export const calculateTotal = (arr) => {
  if (!arr || arr?.length === 0) return 0;

  const total = arr.reduce((acc, val) => acc + val, 0);

  return total.toFixed(2);
};

export const displayActionMessage = (msg, status = 'info') => {
  const div = document.createElement('div');
  const span = document.createElement('span');

  div.className = `toast ${
    status === 'info'
      ? 'toast-info'
      : status === 'success'
      ? 'toast-success'
      : 'toast-error'
  }`;
  span.className = 'toast-msg';
  span.textContent = i18n.t(msg);
  div.appendChild(span);

  if (document.querySelector('.toast')) {
    document.body.removeChild(document.querySelector('.toast'));
    document.body.appendChild(div);
  } else {
    document.body.appendChild(div);
  }

  setTimeout(() => {
    try {
      document.body.removeChild(div);
    } catch (e) {
      console.error(e);
    }
  }, 3000);
};

export const splitName = (fullname) => {
  const splitted = fullname.split(' ');
  return `${splitted[0]} ${splitted[1].charAt(0)}.`;
};

export const shuffleArray = (a) => {
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    // eslint-disable-next-line no-param-reassign
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};
